import { noop } from '@panwds/react-ui';
import React, { createContext, useReducer } from 'react';
import '../../state/actions.esm.js';
import { initialState, reducer } from '../../state/reducer.esm.js';

const FilterContext = createContext({
    state: initialState,
    dispatch: noop
});
/**
 * Manages the state for all filters. Place it at the root of your React tree.
 *
 * ### Import Guide
 *
 * ```jsx
 * import { GlobalFilterProvider } from "@panwds/react-filters";
 * ```
 */
const GlobalFilterProvider = (props) => {
    const { children, initialState: initialState$1 } = props;
    const [state, dispatch] = useReducer(reducer, initialState$1 || initialState);
    return (React.createElement(FilterContext.Provider, { value: {
            dispatch,
            state
        } }, children));
};

export { FilterContext, GlobalFilterProvider };
//# sourceMappingURL=GlobalFilterProvider.esm.js.map
